export const environment = {
  envName: 'DEV',
  apiUrl: 'https://nanaykuna-unicon-dev-bff-api-ctn-app-001.azurewebsites.net/',
  socketUrl:
    'wss://nanaykuna-unicon-dev-bff-api-ctn-app-001.azurewebsites.net/',
  googleMaps: {
    apiKey: 'AIzaSyCEOj2bXV6MheQOnGej_p2HZoTenfSV65k',
    mapId: 'c56bf6988e91a407c78ecaa5',
  },
};
